export class TerminaisNacionaisModel {
  id_terminal: number;
  nome: string;
  cidade: string;
  estado: string = 'SP';
}



// WEBPACK FOOTER //
// ./src/app/terminais-nacionais/terminais-nacionais.model.ts